export enum ServiceCostEstimateChannel {
  CREATE = 'serviceCostEstimate::create',
  EDIT = 'serviceCostEstimate::patch',
  DELETE = 'serviceCostEstimate::delete',
}
